import { render, staticRenderFns } from "./GeorepreportFormHeader.vue?vue&type=template&id=3a277028"
import script from "./GeorepreportFormHeader.vue?vue&type=script&lang=js"
export * from "./GeorepreportFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports